import { Injectable } from '@angular/core';
import { MessageChannelService } from "@bndes/bndes-ux4/bndes-angular-utils"; 
import { messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
  providedIn: 'root'
})
export class MensagemService {

  constructor(private mensagemService: MessageChannelService) {}

  public adicionarMensagemSucesso(mensagem: string, titulo : string ='Sucesso') : void{
    this.mensagemService.addMessage({
      title: titulo,
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: mensagem,
      timeout: 8000,
    }); 
  }

  public adicionarMensagemAviso(mensagem: string, titulo : string ='Aviso'): void{
    this.mensagemService.addMessage({
      title: titulo,
      type: 'CRUD_OPERATION',
      level: messageLevel.WARNING,
      message: mensagem,
      timeout: 8000,
    }); 
  }

  public adicionarMensagemErro(mensagem: string, titulo : string ='Erro'): void{
    this.mensagemService.addMessage({
      title: titulo,
      type: 'CRUD_OPERATION',
      level: messageLevel.ERROR,
      message: mensagem,
      timeout: 8000,
    }); 
  }
}
